import React from 'react';
import { BiCopy, BiPlay } from 'react-icons/bi';
import ReactPlayer from 'react-player';

export default function AboutSection4() {
    return (
        <div className="flex xl:gap-20 xl:min-h-screen pb-20 xl:py-0 dark:bg-zinc-900 xl:px-35 px-10 w-[100vw] flex-col xl:flex-row xl:justify-between gap-10">
            {/* Left side - Video section */}
            <div className="flex relative xl:h-[90vh] md:w-[100%] xl:w-[60vw] items-center justify-center pointer-events-auto ">
                {/* <div className='h-fit w-fit'> */}

                    <ReactPlayer
                        src="/videos/Clip1.webm"
                        controls={true}
                        height={"100%"}
                        width={"100%"}
                    />
                {/* </div> */}
            </div>

            {/* Right side - Content section */}
            <div className="xl:w-[38vw] dark:text-white xl:p-8 flex flex-col">
                <div className="flex-1 flex flex-col justify-center w-[100%]">
                    <h1 className="text-3xl font-bold leading-tighter mb-6">
                        More than 15 years providing outreach services to companies all over the world.
                    </h1>

                    <p className="dark:text-gray-300 text-zinc-500 leading-relaxed">
                        Digicots is a digital marketing agency specialising in web design and development.
                        For over 15 years we have been providing outreach services to small, medium and
                        large companies looking to take a step further in their goal of constantly
                        improving day after day.
                    </p>
                </div>
            </div>
        </div>
    );
}